var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "x-dialog",
    {
      attrs: {
        width: _vm.width,
        "max-width": _vm.maxWidth,
        persistent: "",
        "content-class": _vm.contentClass,
      },
      model: {
        value: _vm.isOpen,
        callback: function ($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen",
      },
    },
    [
      _c(
        "x-card",
        { attrs: { light: "" } },
        [
          _c(
            "x-btn",
            {
              staticClass: "close-icon",
              attrs: { color: "", elevation: "2", icon: "", outlined: "" },
              on: {
                click: function ($event) {
                  _vm.isOpen = false
                },
              },
            },
            [_c("x-icon", { attrs: { size: 28 } }, [_vm._v("close")])],
            1
          ),
          _vm._v(" "),
          _c(
            "x-card-title",
            { attrs: { "primary-title": "", "data-test": "modal-title" } },
            [_vm._v(_vm._s(_vm.computedTitle))]
          ),
          _vm._v(" "),
          _c(
            "x-card-text",
            { attrs: { "data-test": "modal-text" } },
            [_vm._t("default")],
            2
          ),
          _vm._v(" "),
          _c(
            "x-card-actions",
            [
              _vm.confirmation
                ? [
                    _c(
                      "x-btn",
                      {
                        attrs: {
                          color: "cancel",
                          "data-test": "modal-cancel-button",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.resolveAndClose(false)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.cancelText))]
                    ),
                    _vm._v(" "),
                    _c(
                      "x-btn",
                      {
                        attrs: {
                          color: "secondary",
                          disabled: _vm.actionDisabled,
                          "data-test": "modal-action-button",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.resolveAndClose(true)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.computedActionText))]
                    ),
                  ]
                : [
                    _c(
                      "x-btn",
                      {
                        attrs: {
                          color: "secondary",
                          disabled: _vm.actionDisabled,
                          "data-test": "modal-action-button",
                        },
                        on: { click: _vm.resolveAndClose },
                      },
                      [_vm._v(_vm._s(_vm.computedActionText))]
                    ),
                  ],
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }